<div class="limits-main-container text">
  <!-- Aylık Deposit Limiti -->
  <div class="limit-container">
    <div class="limit-dropdown-header" (click)="toggleDropDown(0)">
      <div class="limit-header-left-side">{{ 'Deposit_Monthly_Limit_New' | t }}</div>
      <div class="limit-header-right-side">
        <div
          [ngClass]="{
            'svg-arrow-up': montlyLimitDropDownIsOpen,
            'svg-arrow-down': !montlyLimitDropDownIsOpen
          }"></div>
      </div>
    </div>

    <!-- Step1 -->
    <div class="limit-content-container" *ngIf="montlyLimitDropDownIsOpen && limitType === ''">
      <div class="info-content">
        <div class="info-content-row mb-l">
          {{ 'Deposit_Self_limit_1' | t }}
        </div>

        <div class="info-content-row mb-l">
          {{ 'Deposit_Self_limit_2' | t }}
        </div>
        <div class="info-content-row mb-l">
          {{ 'Deposit_Self_limit_3' | t }}
        </div>

        <div class="info-content-row bold-700">
          {{ 'Deposit_Self_limit_4' | t }}
        </div>

        <div class="info-content-row mb-m" *ngIf="DepositMonthlyLimitModel !== 99999; else LugasLimit">
          <div class="info-limit-amount-row mb-10">
            <div class="bold-700">{{ DepositMonthlyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}</div>
            <div style="margin-left: 5px">
              {{ limitDateObj.DepositMounthlyDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
            </div>
          </div>
        </div>
        <div class="info-content-row bold-700">
          {{ 'Deposit_Self_limit_7' | t }}
        </div>

        <div class="info-content-row mb-m" *ngIf="DepositMonthlyLimitModelConsumed && DepositMonthlyLimitModelConsumed !== 99999; else LugasLimit2">
          <div class="info-limit-amount-row mb-10">
            <div class="bold-700">{{ DepositMonthlyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
            <div style="margin-left: 5px">
              {{ limitDateObj.DepositActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
            </div>
          </div>
        </div>
        <ng-template #LugasLimit>
          <div class="info-limit-amount-row mb-10">
            <div>
              {{ 'Deposit_Self_limit_6' | t }}
            </div>
            <div style="margin-left: 5px">
              {{ limitDateObj.DepositMounthlyDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
            </div>
          </div>
        </ng-template>
        <ng-template #LugasLimit2>
          <div class="info-limit-amount-row mb-10">
            <div>
              {{ 'Deposit_Self_limit_6' | t }}
            </div>
            <div style="margin-left: 5px">
              {{ limitDateObj.DepositActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
            </div>
          </div>
        </ng-template>

        <div (click)="changeLimitTab('montly_limit')" class="btn colored register-button save-changes-button confirm-button green">
          <div class="btn-text" style="color: #fff !important">
            {{ 'Limit_Set' | t }}
          </div>
        </div>
        <div class="mt-8">
          {{ 'Deposit_Self_limit_8' | t }}
        </div>
      </div>
    </div>
    <!-- Step2 -->
    <div class="limit-content-container" *ngIf="montlyLimitDropDownIsOpen && limitType === 'montly_limit'">
      <div class="limit-input-row">
        <div class="limit-input-container">
          <div class="input-area">
            <inputb3
              [(ngModel)]="depositMontlyModel"
              extraClass="limitInputs"
              fErrorText="{{ 'Required' | t }}"
              fSuffixText="EUR"
              fPlaceholder="{{ 'Deposit_Limit_2' | t }}"
              placeholder="{{ (depositMontlyModel === 99999 ? 'Deposit_Self_limit_6' : 'Deposit_Limit_2') | t }}"
              fInputType="number"
              fMinVal="1"
              (ngModelChange)="changeLostLimit($event)"></inputb3>
          </div>
        </div>
      </div>

      <div class="button-container">
        <div (click)="changeLimitTab('cancel')" class="btn colored register-button save-changes-button confirm-button flexible error">
          <div class="btn-text" style="color: #fff !important">
            {{ 'b3000_cancel' | t }}
          </div>
        </div>
        <div
          (click)="saveSelfLimitsData2(3)"
          *ngIf="depositMontlyModel <= 30000; else disabledButtonMD"
          class="btn colored register-button save-changes-button confirm-button flexible green">
          <div class="btn-text" style="color: #fff !important">
            {{ 'Confirm' | t }}
          </div>
        </div>
        <ng-template #disabledButtonMD>
          <div style="opacity: 0.5" class="btn colored register-button save-changes-button confirm-button flexible green">
            <div class="btn-text" style="color: #fff !important">
              {{ 'Confirm' | t }}
            </div>
          </div>
        </ng-template>
      </div>

      <div class="scufa-info-container" *ngIf="schufa_Fin_Error || depositMontlyModel > 30000">
        <div class="scufa-info-row">
          <div class="scufa-info-row-left">
            <div class="left-svg">
              <image-loader-utils url="info-circle" extraClasses="back "></image-loader-utils>
            </div>
          </div>

          <ng-container *ngIf="depositMontlyModel > 30000">
            <div class="scufa-info-row-right">
              <span>{{ 'Lugas_Text_17' | t }} </span>
            </div>
          </ng-container>

          <ng-container *ngIf="errorMessageState === 'above10000'">
            <div class="scufa-info-row-right">
              <span
                >{{ 'Lugas_Text_27' | t }}
                <a class="contact-support" (click)="goToVerificationSow()"> {{ 'Lugas_Text_28' | t }}</a>
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="errorMessageState === 'above1000'">
            <div class="scufa-info-row-right">
              <span
                >{{ 'Lugas_Text_27' | t }}
                <a class="contact-support" (click)="goToVerificationSow()"> {{ 'Lugas_Text_28' | t }}</a>
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!--Hesap Dondurma -->

  <div class="limit-container">
    <div class="limit-dropdown-header" (click)="toggleDropDown(6)">
      <div class="limit-header-left-side">{{ 'b3000_Self_exclusion' | t }}</div>
      <div class="limit-header-right-side">
        <div
          [ngClass]="{
            'svg-arrow-up': selfExclusionDropDownIsOpen,
            'svg-arrow-down': !selfExclusionDropDownIsOpen
          }"></div>
      </div>
    </div>

    <div class="limit-content-container" *ngIf="selfExclusionDropDownIsOpen">
      <account-lock-component></account-lock-component>
    </div>
  </div>
  <!-- Hesap Kitleme -->

  <div class="limit-container">
    <div class="limit-dropdown-header" (click)="toggleDropDown(7)">
      <div class="limit-header-left-side">{{ 'b3000_Account_closure' | t }}</div>
      <div class="limit-header-right-side">
        <div
          [ngClass]="{
            'svg-arrow-up': accountClosureDropDownIsOpen,
            'svg-arrow-down': !accountClosureDropDownIsOpen
          }"></div>
      </div>
    </div>

    <div class="limit-content-container account-closure" *ngIf="accountClosureDropDownIsOpen">
      <div class="closure-row">
        {{ 'b3000_self_limit_text_19' | t }}
      </div>

      <div class="limit-input-row">
        <div class="limit-input-container">
          <div class="input-area">
            <input placeholder="{{ 'Password' | t }}" type="password" [(ngModel)]="passwordForClosure" class="password-input" fInputType="number" />
            <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
              <ng-container *ngSwitchCase="'wettarena'">
                <div *ngIf="passwordForClosure; else validPasswordForClosure" class="btn colored register-button save-changes-button" (click)="saveSelfLimitsData()">
                  <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
                </div>
                <ng-template #validPasswordForClosure>
                  <div style="opacity: 0.65" class="btn colored register-button save-changes-button" (click)="saveSelfLimitsData()">
                    <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'b500'">
                <div *ngIf="passwordForClosure; else validPasswordForClosure" class="btn colored register-button save-changes-button" (click)="saveSelfLimitsData()">
                  <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
                </div>
                <ng-template #validPasswordForClosure>
                  <div style="opacity: 0.65" class="btn colored register-button save-changes-button" (click)="saveSelfLimitsData()">
                    <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div *ngIf="passwordForClosure; else validPasswordForClosure" class="btn colored register-button save-changes-button" (click)="checkPassword()">
                  <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
                </div>
                <ng-template #validPasswordForClosure>
                  <div style="opacity: 0.65" class="btn colored register-button save-changes-button">
                    <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sub-text-container">
    <span>
      {{ 'Limit_Condition_Text_1' | t }}
      <a (click)="openDetailLimit()"> {{ 'Limit_Condition_Text_2' | t }} </a>
      {{ 'Limit_Condition_Text_3' | t }}
      <a (click)="openDetailLimit()">{{ 'Limit_Condition_Text_4' | t }} </a>
    </span>
  </div>

  <ng-container *ngIf="isOpenDetailLimit">
    <!-- Bahis ve Kayıp Limiti -->

    <div class="limit-container">
      <div class="limit-dropdown-header" (click)="toggleDropDown(1)">
        <div class="limit-header-left-side">{{ 'Loss_limit' | t }}</div>
        <div class="limit-header-right-side">
          <div
            [ngClass]="{
              'svg-arrow-up': lossLimitDropDownIsOpen,
              'svg-arrow-down': !lossLimitDropDownIsOpen
            }"></div>
        </div>
      </div>

      <!-- Step1 -->
      <div class="limit-content-container" *ngIf="lossLimitDropDownIsOpen && limitType === ''">
        <div class="info-content">
          {{ 'Self_limit_1' | t }}
        </div>
        <div class="sub-header-content">
          {{ 'Example' | t }}
        </div>
        <span>
          {{ 'Self_limit_2' | t }}
        </span>

        <div class="set-time-row">
          <div class="time-box" *ngFor="let time of timeList" [ngClass]="{ active: selectedTime.timeValue === time.timeValue }" (click)="timeBoxClick(time)">
            {{ time?.timeName | t }}
          </div>
        </div>

        <div class="limit-view-container">
          <div class="limit-view-row">
            <div class="limit-view-row-left">
              {{ 'Betting_Limit' | t }}
            </div>
            <div
              class="limit-view-row-right"
              *ngIf="
                (stakeDailyLimitModel === STAKE_DAILY_STANDARD_LIMIT && this.selectedTime.timeName === 'Day') ||
                  (stakeWeeklyLimitModel === STAKE_WEEKLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Week') ||
                  (stakeMontlyLimitModel === STAKE_MONTHLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Month');
                else setLimit1
              ">
              {{ 'standartLimit' | t }}
            </div>
            <ng-template #setLimit1>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Day'">{{ stakeDailyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}</div>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Week'">{{ stakeWeeklyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}</div>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Month'">{{ stakeMontlyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}</div>
            </ng-template>
          </div>

          <!-- Consumed  StakeDaily-->
          <ng-container *ngIf="this.selfLimit.StakeDailyDate !== null && stakeDailyLimitModelConsumed !== stakeDailyLimitModel">
            <div class="limit-view-row small-info">
              <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName === 'Day'">
                {{ 'self_limit_text_1' | t }}
              </div>

              <ng-container>
                <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Day'">
                  <div class="amount">{{ stakeDailyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                  <div class="date">
                    {{ limitDateObj.StakeDailyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Consumed Stake Weekly-->
          <ng-container *ngIf="this.selfLimit.StakeWeeklyDate !== null && stakeWeeklyLimitModelConsumed !== stakeWeeklyLimitModel">
            <div class="limit-view-row small-info">
              <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName === 'Week'">
                {{ 'self_limit_text_1' | t }}
              </div>

              <ng-container>
                <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Week'">
                  <div class="amount">{{ stakeWeeklyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                  <div class="date">
                    {{ limitDateObj.StakeWeeklyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Consumed Stake Monthly-->
          <ng-container *ngIf="this.selfLimit.StakeMonthlyDate !== null && stakeMontlyLimitModelConsumed !== stakeMontlyLimitModel">
            <div class="limit-view-row small-info">
              <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName === 'Month'">
                {{ 'self_limit_text_1' | t }}
              </div>

              <ng-container>
                <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Month'">
                  <div class="amount">{{ stakeMontlyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                  <div class="date">
                    {{ limitDateObj.StakeMonthlyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div class="limit-view-row">
            <div class="limit-view-row-left">
              {{ 'Lost_Limit' | t }}
            </div>
            <div
              class="limit-view-row-right"
              *ngIf="
                (LossDailyLimitModel === LOSS_DAILY_STANDARD_LIMIT && this.selectedTime.timeName === 'Day') ||
                  (LossWeeklyLimitModel === LOSS_WEEKLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Week') ||
                  (LossMonthlyLimitModel === LOSS_MONTHLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Month');
                else setLimit2
              ">
              {{ 'standartLimit' | t }}
            </div>
            <ng-template #setLimit2>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Day'">{{ LossDailyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}</div>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Week'">{{ LossWeeklyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}</div>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Month'">{{ LossMonthlyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}</div>
            </ng-template>
          </div>
          <!-- Consumed  LossDaily-->
          <ng-container *ngIf="this.selfLimit.LossDailyDate !== null && LossDailyLimitModelConsumed !== LossDailyLimitModel">
            <div class="limit-view-row small-info">
              <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName === 'Day'">
                {{ 'self_limit_text_1' | t }}
              </div>

              <ng-container>
                <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Day'">
                  <div class="amount">{{ LossDailyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                  <div class="date">
                    {{ limitDateObj.LossDailyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Consumed Loss Weekly-->
          <ng-container *ngIf="this.selfLimit.LossWeeklyDate !== null && LossWeeklyLimitModelConsumed !== LossWeeklyLimitModel">
            <div class="limit-view-row small-info">
              <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName === 'Week'">
                {{ 'self_limit_text_1' | t }}
              </div>

              <ng-container>
                <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Week'">
                  <div class="amount">{{ LossWeeklyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                  <div class="date">
                    {{ limitDateObj.LossWeeklyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Consumed Loss Monthly-->
          <ng-container *ngIf="this.selfLimit.LossMounthlyDate !== null && LossMonthlyLimitModelConsumed !== LossMonthlyLimitModel">
            <div class="limit-view-row small-info">
              <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName === 'Month'">
                {{ 'self_limit_text_1' | t }}
              </div>

              <ng-container>
                <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Month'">
                  <div class="amount">{{ LossMonthlyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                  <div class="date">
                    {{ limitDateObj.LossMounthlyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <div (click)="changeLimitTab('stake&lost_limit')" class="btn colored register-button save-changes-button confirm-button green">
          <div class="btn-text" style="color: #fff !important">
            {{ 'Limit_Set' | t }}
          </div>
        </div>
      </div>
      <!-- Step2 -->
      <div class="limit-content-container" *ngIf="lossLimitDropDownIsOpen && limitType === 'stake&lost_limit'">
        <div class="limit-input-row">
          <div class="limit-input-container">
            <div class="input-area">
              <inputb3
                [placeholder]="
                  (this.stakeDailyLimitModel === STAKE_DAILY_STANDARD_LIMIT && this.selectedTime.timeName === 'Day') ||
                  (this.stakeWeeklyLimitModel === STAKE_WEEKLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Week') ||
                  (this.stakeMontlyLimitModel === STAKE_MONTHLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Month')
                    ? 'Standardlimit'
                    : ''
                "
                [(ngModel)]="stakeModel"
                extraClass="limitInputs"
                fErrorText="{{ 'Required' | t }}"
                fSuffixText="EUR"
                fPlaceholder="{{ 'Betting_Limit' | t }}"
                fInputType="number"
                fMinVal="1"
                (ngModelChange)="changeLostLimit($event)"></inputb3>
            </div>
          </div>
        </div>
        <div class="limit-input-row">
          <div class="limit-input-container">
            <div class="input-area">
              <inputb3
                [placeholder]="
                  (this.LossDailyLimitModel === LOSS_DAILY_STANDARD_LIMIT && this.selectedTime.timeName === 'Day') ||
                  (this.LossWeeklyLimitModel === LOSS_WEEKLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Week') ||
                  (this.LossMonthlyLimitModel === LOSS_MONTHLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Month')
                    ? 'Standardlimit'
                    : ''
                "
                [(ngModel)]="lostModel"
                extraClass="limitInputs"
                fErrorText="{{ 'Required' | t }}"
                fSuffixText="EUR"
                fPlaceholder="{{ 'Lost_Limit' | t }}"
                fInputType="number"
                fMinVal="1"
                disabled="true">
              </inputb3>
            </div>
          </div>
        </div>

        <div class="button-container">
          <div (click)="changeLimitTab('cancel')" class="btn colored register-button save-changes-button confirm-button flexible error">
            <div class="btn-text" style="color: #fff !important">
              {{ 'b3000_cancel' | t }}
            </div>
          </div>
          <div (click)="saveSelfLimitsData2(1)" *ngIf="stakeModel > 0; else disabledButton" class="btn colored register-button save-changes-button confirm-button flexible green">
            <div class="btn-text" style="color: #fff !important">
              {{ 'Confirm' | t }}
            </div>
          </div>
          <ng-template #disabledButton>
            <div style="opacity: 0.5" class="btn colored register-button save-changes-button confirm-button flexible green">
              <div class="btn-text" style="color: #fff !important">
                {{ 'Confirm' | t }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Deposit Limiti -->

    <div class="limit-container">
      <div class="limit-dropdown-header" (click)="toggleDropDown(3)">
        <div class="limit-header-left-side">{{ 'Deposit_Limit_New' | t }}</div>
        <div class="limit-header-right-side">
          <div
            [ngClass]="{
              'svg-arrow-up': depositLimitDropDownIsOpen,
              'svg-arrow-down': !depositLimitDropDownIsOpen
            }"></div>
        </div>
      </div>

      <!-- Step1 -->
      <div class="limit-content-container" *ngIf="depositLimitDropDownIsOpen && limitType === ''">
        <div class="info-content">
          <ng-container [ngSwitch]="['b3000'] | getProductName">
            <ng-container *ngSwitchCase="'b3000'">
              <div class="info-content-row">
                {{ 'b3000_self_limit_text' | t }}
              </div>
            </ng-container>
          </ng-container>
          <ng-container [ngSwitch]="['wettarena'] | getProductName">
            <ng-container *ngSwitchCase="'wettarena'">
              <div class="info-content-row">
                {{ 'wa_self_limit_text' | t }}
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="set-time-row">
          <div class="time-box" *ngFor="let time of timeList2" [ngClass]="{ active: selectedTime.timeValue === time.timeValue }" (click)="timeBoxClick(time)">
            <div>
              {{ time?.timeName | t }}
            </div>
          </div>
        </div>

        <div class="limit-view-container">
          <div class="limit-view-row">
            <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName !== 'Month'">
              {{ 'Deposit_Limit_2' | t }}
            </div>
            <!-- *ngIf="this.limitDateObj.IsFirstSet && this.selectedTime.timeName==='Day' && this.DepositDailyLimitModel===1000; else setLimit3"> -->
            <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Day' && this.DepositDailyLimitModel === DEPOSIT_DAILY_STANDARD_LIMIT; else setLimit3">
              {{ 'standartLimit' | t }}
            </div>
            <ng-template #setLimit3>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Day' && this.selectedTime.timeName !== 'Month'">
                {{ DepositDailyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}
              </div>
            </ng-template>
            <!-- *ngIf="this.limitDateObj.IsFirstSet && this.selectedTime.timeName==='Week' && this.DepositWeeklyLimitModel===1000; else setLimit4"> -->
            <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Week' && this.DepositWeeklyLimitModel === DEPOSIT_WEEKLY_STANDARD_LIMIT; else setLimit4">
              {{ 'standartLimit' | t }}
            </div>
            <ng-template #setLimit4>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Week' && this.selectedTime.timeName !== 'Month'">
                {{ DepositWeeklyLimitModel }} {{ this._UserHelper.customerUser.Symbol }}
              </div>
            </ng-template>
          </div>

          <div class="limit-view-row small-info" *ngIf="this.selfLimit.DepositDailyDate !== null && DepositDailyLimitModelConsumed !== DepositDailyLimitModel">
            <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName !== 'Month' && this.selectedTime.timeName === 'Day'">
              {{ 'self_limit_text_1' | t }}
            </div>

            <ng-container>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Day' && this.selectedTime.timeName !== 'Month'">
                <div class="amount">{{ DepositDailyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                <div class="date">
                  {{ limitDateObj.DepositDailyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                </div>
              </div>
            </ng-container>
          </div>

          <div class="limit-view-row small-info" *ngIf="this.selfLimit.DepositWeeklyActivityDate !== null && DepositWeeklyLimitModelConsumed !== DepositWeeklyLimitModel">
            <div class="limit-view-row-left" *ngIf="this.selectedTime.timeName !== 'Month' && this.selectedTime.timeName === 'Week'">
              {{ 'self_limit_text_1' | t }}
            </div>

            <ng-container>
              <div class="limit-view-row-right" *ngIf="this.selectedTime.timeName === 'Week' && this.selectedTime.timeName !== 'Month'">
                <div class="amount">{{ DepositWeeklyLimitModelConsumed }} {{ this._UserHelper.customerUser.Symbol }}</div>
                <div class="date">
                  {{ limitDateObj.DepositWeeklyActivityDate | dateFormat : 'dd.MM.yyyy H:mm:ss' }}
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div
          (click)="changeLimitTab('deposit')"
          *ngIf="selectedTime.timeName === 'Day' || selectedTime.timeName === 'Week'"
          class="btn colored register-button save-changes-button confirm-button green">
          <div class="btn-text" style="color: #fff !important">
            {{ 'Limit_Set' | t }}
          </div>
        </div>
      </div>

      <!-- Step2 -->
      <div class="limit-content-container" *ngIf="depositLimitDropDownIsOpen && limitType === 'deposit'">
        <div class="limit-input-row">
          <div class="limit-input-container">
            <div class="input-area">
              <inputb3
                [placeholder]="
                  (this.DepositDailyLimitModel === DEPOSIT_DAILY_STANDARD_LIMIT && this.selectedTime.timeName === 'Day') ||
                  (this.DepositWeeklyLimitModel === DEPOSIT_WEEKLY_STANDARD_LIMIT && this.selectedTime.timeName === 'Week')
                    ? 'Standardlimit'
                    : ''
                "
                [(ngModel)]="depositModel"
                extraClass="limitInputs"
                fErrorText="{{ 'Required' | t }}"
                fSuffixText="EUR"
                fPlaceholder="{{ 'Deposit_Limit_2' | t }}"
                fInputType="number"
                fMinVal="1"
                (ngModelChange)="changeLostLimit($event)"></inputb3>
            </div>
          </div>
        </div>

        <div class="button-container">
          <div (click)="changeLimitTab('cancel')" class="btn colored register-button save-changes-button confirm-button flexible error">
            <div class="btn-text" style="color: #fff !important">
              {{ 'b3000_cancel' | t }}
            </div>
          </div>
          <div
            (click)="saveSelfLimitsData2(2)"
            *ngIf="depositModel && depositModel <= 30000; else disabledButton2"
            class="btn colored register-button save-changes-button confirm-button flexible green">
            <div class="btn-text" style="color: #fff !important">
              {{ 'Confirm' | t }}
            </div>
          </div>

          <ng-template #disabledButton2>
            <div style="opacity: 0.5" class="btn colored register-button save-changes-button confirm-button flexible green">
              <div class="btn-text" style="color: #fff !important">
                {{ 'Confirm' | t }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</div>
